<template>
  <div
    class="edit-toggle-containter"
    :class="editMode ? 'edit-active' : 'edit-inactive'"
    @click="toggleEditMode"
    >
    <div class="toggle-message">{{ editMode ? 'stop editing' : 'engage edit' }}</div>
  </div>
</template>
<script>
export default {
  data: () => ({
    editMode: false,
  }),
  props: {
    callback: {
      type: Function,
      required: true,
    },
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      this.callback(this.editMode);
    },
  },
};
</script>
<style lang="stylus" scoped>
  @require '../style/colors'
  .edit-toggle-containter
    display: flex
    justify-content: center
    align-items: center
    margin-right: 3rem
    min-width: 12rem
    height: 3.1rem
    padding: 0.5rem
    border-radius: 2.5rem
    cursor: pointer

    &.edit-active
      background-color: $white
      color: #FF5500
      border: 1px solid $primary-color

      &:hover
        padding: 0.2rem
        border: 0.5rem double $primary-color

    &.edit-inactive
      background-color: $primary-color
      color: #FFF
      border: 1px solid $white

      &:hover
        padding: 0.2rem
        border: 0.5rem double $white

    .toggle-message
      font-size: 1.5rem

</style>
